import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import MuiTextField, { TextFieldProps } from "@material-ui/core/TextField";

const StyledTextFields = styled(MuiTextField)`
    // removes browser's default html input arrows for numeric types
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }
`;

export const TextField = styled(
    ({
        backgroundColor = "inherit",
        errorMessage,
        ...props
    }: TextFieldProps & { backgroundColor?: string; errorMessage?: string }) => (
        <>
            <StyledTextFields
                {...props}
                InputLabelProps={{ ...props.InputLabelProps, shrink: true }}
                InputProps={{ ...props.InputProps, style: { backgroundColor } }}
            />
            {errorMessage && (
                <Typography variant="caption" component="span" color="error" style={{ fontSize: "12px" }}>
                    {errorMessage}
                </Typography>
            )}
        </>
    )
)<TextFieldProps>``;
